import { Component } from '@angular/core';

import { LogoutMemberService } from '@genesis-frontend/genesis-utilities';

@Component({
    templateUrl: './no-product.component.html',
    styleUrl: './no-product.component.scss'
})
export class NoProductComponent {
    constructor(private logoutService: LogoutMemberService) {}

    logout(): void {
        this.logoutService.logout(false);
    }
}
